module.exports = __webpack_public_path__ + "@/assets/img/telephone.480f71e5.png";